import { HttpClient , HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import { setting } from '../../setting';
import { Observable } from 'rxjs';

@Injectable()

export class AppService {
	public baseUrl: string;
	public apiBookingUrl: string;
	constructor(private _http: HttpClient) {
		this.baseUrl = setting.authApiUrl;
		this.apiBookingUrl = setting.apiBookingUrl
	}
	getClientsSettingAppBooking() {
		let params: HttpParams = new HttpParams();
		params = params.set('name', setting.name);
    const url = `${this.baseUrl}getClientsSettingAppBooking?name=${setting.name}`

		return this._http.get(url);
	}

  clientsApplications(clientId: any): Observable<any> {
    if(clientId) {
      const url = `${setting.authApiUrl}application/clients?client_id=${clientId}`;

      return this._http.get<any>(url);
    }
  }

    	getConsultUpdatedClient() {
		let params: HttpParams = new HttpParams();
		params = params.set('name', setting.name);
		return this._http.get(setting.authApiUrl + 'clients-updates', { params: params });
	}
}
